const RICOS_VERSION = "10.145.1";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
